import React, { Component } from "react";
import { Breadcrumb, Container, Button, Form } from 'react-bootstrap';
import RouterHistory from '../../Router/RouterHistory';
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout.jsx';
import { LinkTo } from '../../PageLayout/Link/Link';
import ClassicTitledTile from '../Project/component/ClassicTitledTile';
import Spinner from "../../PageLayout/Spinner";
import UserService from "../../Services/UserService";
import ApiService from "../../Services/ApiService";
import AppConfig from '../../Configuration/AppConfig';
import Markdown from '../Project/component/Markdown';
import logo from "images/codai.svg";

class UserConsent extends Component {
  constructor() {
    super();
    this.state = {
      isAppConsentLoading: true,
      hasAppConsent: null,
      consentText: ''
    };
    this.userService = UserService;
    this.isAppConsentEnabled = AppConfig.Features.IsAppConsentEnabled;
  }

  componentDidMount() {
    this.userService.HasAppConsent().then((check) => { this.setState({ "hasAppConsent": check, "isAppConsentLoading": false }); });
    ApiService.StaticFetch('md/UserCodaiPortalConsent.md').then((response) => {
      response.text().then((text) => {
        this.setState({ "consentText": text });
      });
    });
  }

  grantConsent = () => {
    this.setState({ isAppConsentLoading: true }, () => {
      this.userService.GrantAppConsent().then(() => {
        this.setState({ hasAppConsent: true, isAppConsentLoading: false }, () => {
          //Redirect to Home
          setTimeout(() => RouterHistory.push('/'), 2500);
        });
      });
    });
  }

  render() {
    let consentBlock = null;
    if (this.isAppConsentEnabled) {
      if (this.state.hasAppConsent) {
        consentBlock = (
          <Form.Group>
            <i className='icon-circle-checked' />{" "}
            <Form.Label>You have granted your consent.</Form.Label>
          </Form.Group>
        );
      } else {
        if (this.state.isAppConsentLoading) {
          consentBlock = <Spinner />;
        }
        else {
          consentBlock = (
            <>
              <Form.Group>
                <Form.Label >Your consent is required fot further navigation. Please grant it.</Form.Label>
                <br />
                <Button variant="primary" onClick={() => this.grantConsent()}>Grant Consent</Button>
              </Form.Group>
            </>
          );
        }
      }
    }

    return (
      <MainPagesLayout className='HomePage'>
        <Breadcrumb className={'breadCrumb'}>
          <Breadcrumb.Item {...LinkTo('/')}>
            <img alt="CoDAI" src={logo} />
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            Terms of Service
          </Breadcrumb.Item>
        </Breadcrumb>
        <ClassicTitledTile title={(
          <h3 className="bigTitledTile">
            {"Terms of service"}
          </h3>
        )}>
          <Container className='' >
            <Markdown projectId={null} maxSize={700} path={null}>{this.state.consentText}</Markdown>
          </Container>
          < br />
          {consentBlock}
        </ClassicTitledTile>
      </MainPagesLayout>
    );
  }
}

export default UserConsent;
